// source: User_message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.FileManagement', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.FileUploadError', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.User', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.UserEmail', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.UserFile', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.UserGroup', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.UserResult', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.UserRole', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.UserRoleResult', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.UserTerritory', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.UserToDelete', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.UserUpdate', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.User = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.GroupManagement.User.v1.User.repeatedFields_, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.User, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.User.displayName = 'proto.Olameter.GroupManagement.User.v1.User';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.UserRole = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.UserRole, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.UserRole.displayName = 'proto.Olameter.GroupManagement.User.v1.UserRole';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.UserGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.UserGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.UserGroup.displayName = 'proto.Olameter.GroupManagement.User.v1.UserGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.UserTerritory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.UserTerritory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.UserTerritory.displayName = 'proto.Olameter.GroupManagement.User.v1.UserTerritory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.GroupManagement.User.v1.UserUpdate.repeatedFields_, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.UserUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.UserUpdate.displayName = 'proto.Olameter.GroupManagement.User.v1.UserUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.UserResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.GroupManagement.User.v1.UserResult.repeatedFields_, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.UserResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.UserResult.displayName = 'proto.Olameter.GroupManagement.User.v1.UserResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.UserToDelete = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.UserToDelete, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.UserToDelete.displayName = 'proto.Olameter.GroupManagement.User.v1.UserToDelete';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.UserRoleResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.UserRoleResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.UserRoleResult.displayName = 'proto.Olameter.GroupManagement.User.v1.UserRoleResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.UserEmail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.UserEmail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.UserEmail.displayName = 'proto.Olameter.GroupManagement.User.v1.UserEmail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.FileManagement = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.FileManagement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.FileManagement.displayName = 'proto.Olameter.GroupManagement.User.v1.FileManagement';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.FileUploadError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.FileUploadError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.FileUploadError.displayName = 'proto.Olameter.GroupManagement.User.v1.FileUploadError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.UserFile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.UserFile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.UserFile.displayName = 'proto.Olameter.GroupManagement.User.v1.UserFile';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.GroupManagement.User.v1.User.repeatedFields_ = [7,8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.User.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.User} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.User.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
userName: jspb.Message.getFieldWithDefault(msg, 2, ""),
email: jspb.Message.getFieldWithDefault(msg, 3, ""),
phoneNumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
company: jspb.Message.getFieldWithDefault(msg, 5, ""),
title: jspb.Message.getFieldWithDefault(msg, 6, ""),
userRolesList: jspb.Message.toObjectList(msg.getUserRolesList(),
    proto.Olameter.GroupManagement.User.v1.UserRole.toObject, includeInstance),
userGroupsList: jspb.Message.toObjectList(msg.getUserGroupsList(),
    proto.Olameter.GroupManagement.User.v1.UserGroup.toObject, includeInstance),
userTerritoriesList: jspb.Message.toObjectList(msg.getUserTerritoriesList(),
    proto.Olameter.GroupManagement.User.v1.UserTerritory.toObject, includeInstance),
status: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
auditUser: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
userFile: (f = msg.getUserFile()) && proto.Olameter.GroupManagement.User.v1.UserFile.toObject(includeInstance, f),
employeeNumber: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.User}
 */
proto.Olameter.GroupManagement.User.v1.User.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.User;
  return proto.Olameter.GroupManagement.User.v1.User.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.User} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.User}
 */
proto.Olameter.GroupManagement.User.v1.User.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompany(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 7:
      var value = new proto.Olameter.GroupManagement.User.v1.UserRole;
      reader.readMessage(value,proto.Olameter.GroupManagement.User.v1.UserRole.deserializeBinaryFromReader);
      msg.addUserRoles(value);
      break;
    case 8:
      var value = new proto.Olameter.GroupManagement.User.v1.UserGroup;
      reader.readMessage(value,proto.Olameter.GroupManagement.User.v1.UserGroup.deserializeBinaryFromReader);
      msg.addUserGroups(value);
      break;
    case 9:
      var value = new proto.Olameter.GroupManagement.User.v1.UserTerritory;
      reader.readMessage(value,proto.Olameter.GroupManagement.User.v1.UserTerritory.deserializeBinaryFromReader);
      msg.addUserTerritories(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStatus(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAuditUser(value);
      break;
    case 12:
      var value = new proto.Olameter.GroupManagement.User.v1.UserFile;
      reader.readMessage(value,proto.Olameter.GroupManagement.User.v1.UserFile.deserializeBinaryFromReader);
      msg.setUserFile(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.User.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.User} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.User.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCompany();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getUserRolesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.Olameter.GroupManagement.User.v1.UserRole.serializeBinaryToWriter
    );
  }
  f = message.getUserGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.Olameter.GroupManagement.User.v1.UserGroup.serializeBinaryToWriter
    );
  }
  f = message.getUserTerritoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.Olameter.GroupManagement.User.v1.UserTerritory.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getAuditUser();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getUserFile();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.Olameter.GroupManagement.User.v1.UserFile.serializeBinaryToWriter
    );
  }
  f = message.getEmployeeNumber();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.User} returns this
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_name = 2;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.User} returns this
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string email = 3;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.User} returns this
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string phone_number = 4;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.getPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.User} returns this
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string company = 5;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.getCompany = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.User} returns this
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.setCompany = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string title = 6;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.User} returns this
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated UserRole user_roles = 7;
 * @return {!Array<!proto.Olameter.GroupManagement.User.v1.UserRole>}
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.getUserRolesList = function() {
  return /** @type{!Array<!proto.Olameter.GroupManagement.User.v1.UserRole>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.GroupManagement.User.v1.UserRole, 7));
};


/**
 * @param {!Array<!proto.Olameter.GroupManagement.User.v1.UserRole>} value
 * @return {!proto.Olameter.GroupManagement.User.v1.User} returns this
*/
proto.Olameter.GroupManagement.User.v1.User.prototype.setUserRolesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.Olameter.GroupManagement.User.v1.UserRole=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRole}
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.addUserRoles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.Olameter.GroupManagement.User.v1.UserRole, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.GroupManagement.User.v1.User} returns this
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.clearUserRolesList = function() {
  return this.setUserRolesList([]);
};


/**
 * repeated UserGroup user_groups = 8;
 * @return {!Array<!proto.Olameter.GroupManagement.User.v1.UserGroup>}
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.getUserGroupsList = function() {
  return /** @type{!Array<!proto.Olameter.GroupManagement.User.v1.UserGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.GroupManagement.User.v1.UserGroup, 8));
};


/**
 * @param {!Array<!proto.Olameter.GroupManagement.User.v1.UserGroup>} value
 * @return {!proto.Olameter.GroupManagement.User.v1.User} returns this
*/
proto.Olameter.GroupManagement.User.v1.User.prototype.setUserGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.Olameter.GroupManagement.User.v1.UserGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.GroupManagement.User.v1.UserGroup}
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.addUserGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.Olameter.GroupManagement.User.v1.UserGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.GroupManagement.User.v1.User} returns this
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.clearUserGroupsList = function() {
  return this.setUserGroupsList([]);
};


/**
 * repeated UserTerritory user_territories = 9;
 * @return {!Array<!proto.Olameter.GroupManagement.User.v1.UserTerritory>}
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.getUserTerritoriesList = function() {
  return /** @type{!Array<!proto.Olameter.GroupManagement.User.v1.UserTerritory>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.GroupManagement.User.v1.UserTerritory, 9));
};


/**
 * @param {!Array<!proto.Olameter.GroupManagement.User.v1.UserTerritory>} value
 * @return {!proto.Olameter.GroupManagement.User.v1.User} returns this
*/
proto.Olameter.GroupManagement.User.v1.User.prototype.setUserTerritoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.Olameter.GroupManagement.User.v1.UserTerritory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.GroupManagement.User.v1.UserTerritory}
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.addUserTerritories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.Olameter.GroupManagement.User.v1.UserTerritory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.GroupManagement.User.v1.User} returns this
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.clearUserTerritoriesList = function() {
  return this.setUserTerritoriesList([]);
};


/**
 * optional bool status = 10;
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.getStatus = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.GroupManagement.User.v1.User} returns this
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.setStatus = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool audit_user = 11;
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.getAuditUser = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.GroupManagement.User.v1.User} returns this
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.setAuditUser = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional UserFile user_file = 12;
 * @return {?proto.Olameter.GroupManagement.User.v1.UserFile}
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.getUserFile = function() {
  return /** @type{?proto.Olameter.GroupManagement.User.v1.UserFile} */ (
    jspb.Message.getWrapperField(this, proto.Olameter.GroupManagement.User.v1.UserFile, 12));
};


/**
 * @param {?proto.Olameter.GroupManagement.User.v1.UserFile|undefined} value
 * @return {!proto.Olameter.GroupManagement.User.v1.User} returns this
*/
proto.Olameter.GroupManagement.User.v1.User.prototype.setUserFile = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.GroupManagement.User.v1.User} returns this
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.clearUserFile = function() {
  return this.setUserFile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.hasUserFile = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string employee_number = 13;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.getEmployeeNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.User} returns this
 */
proto.Olameter.GroupManagement.User.v1.User.prototype.setEmployeeNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.UserRole.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.UserRole.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.UserRole} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserRole.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
userRoleName: jspb.Message.getFieldWithDefault(msg, 2, ""),
active: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRole}
 */
proto.Olameter.GroupManagement.User.v1.UserRole.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.UserRole;
  return proto.Olameter.GroupManagement.User.v1.UserRole.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserRole} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRole}
 */
proto.Olameter.GroupManagement.User.v1.UserRole.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserRoleName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.UserRole.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.UserRole.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserRole} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserRole.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserRoleName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserRole.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRole} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserRole.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_role_name = 2;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserRole.prototype.getUserRoleName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRole} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserRole.prototype.setUserRoleName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool active = 3;
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.UserRole.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRole} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserRole.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.UserGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.UserGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.UserGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
userGroupName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserGroup}
 */
proto.Olameter.GroupManagement.User.v1.UserGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.UserGroup;
  return proto.Olameter.GroupManagement.User.v1.UserGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserGroup}
 */
proto.Olameter.GroupManagement.User.v1.UserGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserGroupName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.UserGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.UserGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserGroupName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserGroup.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserGroup} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserGroup.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_group_name = 2;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserGroup.prototype.getUserGroupName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserGroup} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserGroup.prototype.setUserGroupName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.UserTerritory.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.UserTerritory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.UserTerritory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserTerritory.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
territoryName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserTerritory}
 */
proto.Olameter.GroupManagement.User.v1.UserTerritory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.UserTerritory;
  return proto.Olameter.GroupManagement.User.v1.UserTerritory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserTerritory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserTerritory}
 */
proto.Olameter.GroupManagement.User.v1.UserTerritory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTerritoryName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.UserTerritory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.UserTerritory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserTerritory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserTerritory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTerritoryName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserTerritory.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserTerritory} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserTerritory.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string territory_name = 2;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserTerritory.prototype.getTerritoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserTerritory} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserTerritory.prototype.setTerritoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.repeatedFields_ = [7,8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.UserUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.UserUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
userName: jspb.Message.getFieldWithDefault(msg, 2, ""),
email: jspb.Message.getFieldWithDefault(msg, 3, ""),
phoneNumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
company: jspb.Message.getFieldWithDefault(msg, 5, ""),
title: jspb.Message.getFieldWithDefault(msg, 6, ""),
userRolesList: jspb.Message.toObjectList(msg.getUserRolesList(),
    proto.Olameter.GroupManagement.User.v1.UserRole.toObject, includeInstance),
userGroupsList: jspb.Message.toObjectList(msg.getUserGroupsList(),
    proto.Olameter.GroupManagement.User.v1.UserGroup.toObject, includeInstance),
userTerritoriesList: jspb.Message.toObjectList(msg.getUserTerritoriesList(),
    proto.Olameter.GroupManagement.User.v1.UserTerritory.toObject, includeInstance),
status: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
auditUser: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
userFile: (f = msg.getUserFile()) && proto.Olameter.GroupManagement.User.v1.UserFile.toObject(includeInstance, f),
fileUpload: (f = msg.getFileUpload()) && proto.Olameter.GroupManagement.User.v1.FileManagement.toObject(includeInstance, f),
employeeNumber: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.UserUpdate;
  return proto.Olameter.GroupManagement.User.v1.UserUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompany(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 7:
      var value = new proto.Olameter.GroupManagement.User.v1.UserRole;
      reader.readMessage(value,proto.Olameter.GroupManagement.User.v1.UserRole.deserializeBinaryFromReader);
      msg.addUserRoles(value);
      break;
    case 8:
      var value = new proto.Olameter.GroupManagement.User.v1.UserGroup;
      reader.readMessage(value,proto.Olameter.GroupManagement.User.v1.UserGroup.deserializeBinaryFromReader);
      msg.addUserGroups(value);
      break;
    case 9:
      var value = new proto.Olameter.GroupManagement.User.v1.UserTerritory;
      reader.readMessage(value,proto.Olameter.GroupManagement.User.v1.UserTerritory.deserializeBinaryFromReader);
      msg.addUserTerritories(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStatus(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAuditUser(value);
      break;
    case 12:
      var value = new proto.Olameter.GroupManagement.User.v1.UserFile;
      reader.readMessage(value,proto.Olameter.GroupManagement.User.v1.UserFile.deserializeBinaryFromReader);
      msg.setUserFile(value);
      break;
    case 13:
      var value = new proto.Olameter.GroupManagement.User.v1.FileManagement;
      reader.readMessage(value,proto.Olameter.GroupManagement.User.v1.FileManagement.deserializeBinaryFromReader);
      msg.setFileUpload(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.UserUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCompany();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getUserRolesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.Olameter.GroupManagement.User.v1.UserRole.serializeBinaryToWriter
    );
  }
  f = message.getUserGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.Olameter.GroupManagement.User.v1.UserGroup.serializeBinaryToWriter
    );
  }
  f = message.getUserTerritoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.Olameter.GroupManagement.User.v1.UserTerritory.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getAuditUser();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getUserFile();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.Olameter.GroupManagement.User.v1.UserFile.serializeBinaryToWriter
    );
  }
  f = message.getFileUpload();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.Olameter.GroupManagement.User.v1.FileManagement.serializeBinaryToWriter
    );
  }
  f = message.getEmployeeNumber();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_name = 2;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string email = 3;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string phone_number = 4;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.getPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string company = 5;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.getCompany = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.setCompany = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string title = 6;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated UserRole user_roles = 7;
 * @return {!Array<!proto.Olameter.GroupManagement.User.v1.UserRole>}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.getUserRolesList = function() {
  return /** @type{!Array<!proto.Olameter.GroupManagement.User.v1.UserRole>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.GroupManagement.User.v1.UserRole, 7));
};


/**
 * @param {!Array<!proto.Olameter.GroupManagement.User.v1.UserRole>} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate} returns this
*/
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.setUserRolesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.Olameter.GroupManagement.User.v1.UserRole=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRole}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.addUserRoles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.Olameter.GroupManagement.User.v1.UserRole, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.clearUserRolesList = function() {
  return this.setUserRolesList([]);
};


/**
 * repeated UserGroup user_groups = 8;
 * @return {!Array<!proto.Olameter.GroupManagement.User.v1.UserGroup>}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.getUserGroupsList = function() {
  return /** @type{!Array<!proto.Olameter.GroupManagement.User.v1.UserGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.GroupManagement.User.v1.UserGroup, 8));
};


/**
 * @param {!Array<!proto.Olameter.GroupManagement.User.v1.UserGroup>} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate} returns this
*/
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.setUserGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.Olameter.GroupManagement.User.v1.UserGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.GroupManagement.User.v1.UserGroup}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.addUserGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.Olameter.GroupManagement.User.v1.UserGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.clearUserGroupsList = function() {
  return this.setUserGroupsList([]);
};


/**
 * repeated UserTerritory user_territories = 9;
 * @return {!Array<!proto.Olameter.GroupManagement.User.v1.UserTerritory>}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.getUserTerritoriesList = function() {
  return /** @type{!Array<!proto.Olameter.GroupManagement.User.v1.UserTerritory>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.GroupManagement.User.v1.UserTerritory, 9));
};


/**
 * @param {!Array<!proto.Olameter.GroupManagement.User.v1.UserTerritory>} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate} returns this
*/
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.setUserTerritoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.Olameter.GroupManagement.User.v1.UserTerritory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.GroupManagement.User.v1.UserTerritory}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.addUserTerritories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.Olameter.GroupManagement.User.v1.UserTerritory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.clearUserTerritoriesList = function() {
  return this.setUserTerritoriesList([]);
};


/**
 * optional bool status = 10;
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.getStatus = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.setStatus = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool audit_user = 11;
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.getAuditUser = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.setAuditUser = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional UserFile user_file = 12;
 * @return {?proto.Olameter.GroupManagement.User.v1.UserFile}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.getUserFile = function() {
  return /** @type{?proto.Olameter.GroupManagement.User.v1.UserFile} */ (
    jspb.Message.getWrapperField(this, proto.Olameter.GroupManagement.User.v1.UserFile, 12));
};


/**
 * @param {?proto.Olameter.GroupManagement.User.v1.UserFile|undefined} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate} returns this
*/
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.setUserFile = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.clearUserFile = function() {
  return this.setUserFile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.hasUserFile = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional FileManagement file_upload = 13;
 * @return {?proto.Olameter.GroupManagement.User.v1.FileManagement}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.getFileUpload = function() {
  return /** @type{?proto.Olameter.GroupManagement.User.v1.FileManagement} */ (
    jspb.Message.getWrapperField(this, proto.Olameter.GroupManagement.User.v1.FileManagement, 13));
};


/**
 * @param {?proto.Olameter.GroupManagement.User.v1.FileManagement|undefined} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate} returns this
*/
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.setFileUpload = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.clearFileUpload = function() {
  return this.setFileUpload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.hasFileUpload = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string employee_number = 14;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.getEmployeeNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdate} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserUpdate.prototype.setEmployeeNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.GroupManagement.User.v1.UserResult.repeatedFields_ = [7,8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.UserResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.UserResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserResult.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
userName: jspb.Message.getFieldWithDefault(msg, 2, ""),
email: jspb.Message.getFieldWithDefault(msg, 3, ""),
phoneNumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
company: jspb.Message.getFieldWithDefault(msg, 5, ""),
title: jspb.Message.getFieldWithDefault(msg, 6, ""),
userRolesList: jspb.Message.toObjectList(msg.getUserRolesList(),
    proto.Olameter.GroupManagement.User.v1.UserRole.toObject, includeInstance),
userGroupsList: jspb.Message.toObjectList(msg.getUserGroupsList(),
    proto.Olameter.GroupManagement.User.v1.UserGroup.toObject, includeInstance),
userTerritoriesList: jspb.Message.toObjectList(msg.getUserTerritoriesList(),
    proto.Olameter.GroupManagement.User.v1.UserTerritory.toObject, includeInstance),
status: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
hasBeenAdded: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
auditUser: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
userFile: (f = msg.getUserFile()) && proto.Olameter.GroupManagement.User.v1.UserFile.toObject(includeInstance, f),
employeeNumber: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.UserResult;
  return proto.Olameter.GroupManagement.User.v1.UserResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompany(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 7:
      var value = new proto.Olameter.GroupManagement.User.v1.UserRole;
      reader.readMessage(value,proto.Olameter.GroupManagement.User.v1.UserRole.deserializeBinaryFromReader);
      msg.addUserRoles(value);
      break;
    case 8:
      var value = new proto.Olameter.GroupManagement.User.v1.UserGroup;
      reader.readMessage(value,proto.Olameter.GroupManagement.User.v1.UserGroup.deserializeBinaryFromReader);
      msg.addUserGroups(value);
      break;
    case 9:
      var value = new proto.Olameter.GroupManagement.User.v1.UserTerritory;
      reader.readMessage(value,proto.Olameter.GroupManagement.User.v1.UserTerritory.deserializeBinaryFromReader);
      msg.addUserTerritories(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStatus(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasBeenAdded(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAuditUser(value);
      break;
    case 13:
      var value = new proto.Olameter.GroupManagement.User.v1.UserFile;
      reader.readMessage(value,proto.Olameter.GroupManagement.User.v1.UserFile.deserializeBinaryFromReader);
      msg.setUserFile(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.UserResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCompany();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getUserRolesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.Olameter.GroupManagement.User.v1.UserRole.serializeBinaryToWriter
    );
  }
  f = message.getUserGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.Olameter.GroupManagement.User.v1.UserGroup.serializeBinaryToWriter
    );
  }
  f = message.getUserTerritoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.Olameter.GroupManagement.User.v1.UserTerritory.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getHasBeenAdded();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getAuditUser();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getUserFile();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.Olameter.GroupManagement.User.v1.UserFile.serializeBinaryToWriter
    );
  }
  f = message.getEmployeeNumber();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_name = 2;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string email = 3;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string phone_number = 4;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.getPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string company = 5;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.getCompany = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.setCompany = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string title = 6;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated UserRole user_roles = 7;
 * @return {!Array<!proto.Olameter.GroupManagement.User.v1.UserRole>}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.getUserRolesList = function() {
  return /** @type{!Array<!proto.Olameter.GroupManagement.User.v1.UserRole>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.GroupManagement.User.v1.UserRole, 7));
};


/**
 * @param {!Array<!proto.Olameter.GroupManagement.User.v1.UserRole>} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult} returns this
*/
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.setUserRolesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.Olameter.GroupManagement.User.v1.UserRole=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRole}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.addUserRoles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.Olameter.GroupManagement.User.v1.UserRole, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.clearUserRolesList = function() {
  return this.setUserRolesList([]);
};


/**
 * repeated UserGroup user_groups = 8;
 * @return {!Array<!proto.Olameter.GroupManagement.User.v1.UserGroup>}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.getUserGroupsList = function() {
  return /** @type{!Array<!proto.Olameter.GroupManagement.User.v1.UserGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.GroupManagement.User.v1.UserGroup, 8));
};


/**
 * @param {!Array<!proto.Olameter.GroupManagement.User.v1.UserGroup>} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult} returns this
*/
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.setUserGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.Olameter.GroupManagement.User.v1.UserGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.GroupManagement.User.v1.UserGroup}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.addUserGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.Olameter.GroupManagement.User.v1.UserGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.clearUserGroupsList = function() {
  return this.setUserGroupsList([]);
};


/**
 * repeated UserTerritory user_territories = 9;
 * @return {!Array<!proto.Olameter.GroupManagement.User.v1.UserTerritory>}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.getUserTerritoriesList = function() {
  return /** @type{!Array<!proto.Olameter.GroupManagement.User.v1.UserTerritory>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.GroupManagement.User.v1.UserTerritory, 9));
};


/**
 * @param {!Array<!proto.Olameter.GroupManagement.User.v1.UserTerritory>} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult} returns this
*/
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.setUserTerritoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.Olameter.GroupManagement.User.v1.UserTerritory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.GroupManagement.User.v1.UserTerritory}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.addUserTerritories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.Olameter.GroupManagement.User.v1.UserTerritory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.clearUserTerritoriesList = function() {
  return this.setUserTerritoriesList([]);
};


/**
 * optional bool status = 10;
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.getStatus = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.setStatus = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool has_been_added = 11;
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.getHasBeenAdded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.setHasBeenAdded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool audit_user = 12;
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.getAuditUser = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.setAuditUser = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional UserFile user_file = 13;
 * @return {?proto.Olameter.GroupManagement.User.v1.UserFile}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.getUserFile = function() {
  return /** @type{?proto.Olameter.GroupManagement.User.v1.UserFile} */ (
    jspb.Message.getWrapperField(this, proto.Olameter.GroupManagement.User.v1.UserFile, 13));
};


/**
 * @param {?proto.Olameter.GroupManagement.User.v1.UserFile|undefined} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult} returns this
*/
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.setUserFile = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.clearUserFile = function() {
  return this.setUserFile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.hasUserFile = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string employee_number = 14;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.getEmployeeNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserResult.prototype.setEmployeeNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.UserToDelete.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.UserToDelete.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.UserToDelete} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserToDelete.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserToDelete}
 */
proto.Olameter.GroupManagement.User.v1.UserToDelete.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.UserToDelete;
  return proto.Olameter.GroupManagement.User.v1.UserToDelete.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserToDelete} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserToDelete}
 */
proto.Olameter.GroupManagement.User.v1.UserToDelete.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.UserToDelete.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.UserToDelete.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserToDelete} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserToDelete.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserToDelete.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserToDelete} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserToDelete.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.UserRoleResult.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.UserRoleResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.UserRoleResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserRoleResult.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
userRoleName: jspb.Message.getFieldWithDefault(msg, 2, ""),
active: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRoleResult}
 */
proto.Olameter.GroupManagement.User.v1.UserRoleResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.UserRoleResult;
  return proto.Olameter.GroupManagement.User.v1.UserRoleResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserRoleResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRoleResult}
 */
proto.Olameter.GroupManagement.User.v1.UserRoleResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserRoleName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.UserRoleResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.UserRoleResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserRoleResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserRoleResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserRoleName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserRoleResult.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRoleResult} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserRoleResult.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_role_name = 2;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserRoleResult.prototype.getUserRoleName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRoleResult} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserRoleResult.prototype.setUserRoleName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool active = 3;
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.UserRoleResult.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRoleResult} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserRoleResult.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.UserEmail.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.UserEmail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.UserEmail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserEmail.toObject = function(includeInstance, msg) {
  var f, obj = {
email: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserEmail}
 */
proto.Olameter.GroupManagement.User.v1.UserEmail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.UserEmail;
  return proto.Olameter.GroupManagement.User.v1.UserEmail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserEmail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserEmail}
 */
proto.Olameter.GroupManagement.User.v1.UserEmail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.UserEmail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.UserEmail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserEmail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserEmail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserEmail.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserEmail} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserEmail.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.FileManagement.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.FileManagement.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.FileManagement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.FileManagement.toObject = function(includeInstance, msg) {
  var f, obj = {
userName: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileExtension: jspb.Message.getFieldWithDefault(msg, 2, ""),
fileName: jspb.Message.getFieldWithDefault(msg, 3, ""),
fileByte: msg.getFileByte_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.FileManagement}
 */
proto.Olameter.GroupManagement.User.v1.FileManagement.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.FileManagement;
  return proto.Olameter.GroupManagement.User.v1.FileManagement.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.FileManagement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.FileManagement}
 */
proto.Olameter.GroupManagement.User.v1.FileManagement.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileExtension(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFileByte(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.FileManagement.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.FileManagement.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.FileManagement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.FileManagement.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileExtension();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFileByte_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
};


/**
 * optional string user_name = 1;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.FileManagement.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.FileManagement} returns this
 */
proto.Olameter.GroupManagement.User.v1.FileManagement.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_extension = 2;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.FileManagement.prototype.getFileExtension = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.FileManagement} returns this
 */
proto.Olameter.GroupManagement.User.v1.FileManagement.prototype.setFileExtension = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string file_name = 3;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.FileManagement.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.FileManagement} returns this
 */
proto.Olameter.GroupManagement.User.v1.FileManagement.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bytes file_byte = 4;
 * @return {!(string|Uint8Array)}
 */
proto.Olameter.GroupManagement.User.v1.FileManagement.prototype.getFileByte = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes file_byte = 4;
 * This is a type-conversion wrapper around `getFileByte()`
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.FileManagement.prototype.getFileByte_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFileByte()));
};


/**
 * optional bytes file_byte = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFileByte()`
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.FileManagement.prototype.getFileByte_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFileByte()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.Olameter.GroupManagement.User.v1.FileManagement} returns this
 */
proto.Olameter.GroupManagement.User.v1.FileManagement.prototype.setFileByte = function(value) {
  return jspb.Message.setProto3BytesField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.FileUploadError.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.FileUploadError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.FileUploadError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.FileUploadError.toObject = function(includeInstance, msg) {
  var f, obj = {
userName: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.FileUploadError}
 */
proto.Olameter.GroupManagement.User.v1.FileUploadError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.FileUploadError;
  return proto.Olameter.GroupManagement.User.v1.FileUploadError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.FileUploadError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.FileUploadError}
 */
proto.Olameter.GroupManagement.User.v1.FileUploadError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.FileUploadError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.FileUploadError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.FileUploadError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.FileUploadError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_name = 1;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.FileUploadError.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.FileUploadError} returns this
 */
proto.Olameter.GroupManagement.User.v1.FileUploadError.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_name = 2;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.FileUploadError.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.FileUploadError} returns this
 */
proto.Olameter.GroupManagement.User.v1.FileUploadError.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.UserFile.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.UserFile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.UserFile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserFile.toObject = function(includeInstance, msg) {
  var f, obj = {
fileName: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
name: jspb.Message.getFieldWithDefault(msg, 3, ""),
timeStamp: (f = msg.getTimeStamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserFile}
 */
proto.Olameter.GroupManagement.User.v1.UserFile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.UserFile;
  return proto.Olameter.GroupManagement.User.v1.UserFile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserFile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserFile}
 */
proto.Olameter.GroupManagement.User.v1.UserFile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimeStamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.UserFile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.UserFile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserFile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserFile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTimeStamp();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string file_name = 1;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserFile.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserFile} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserFile.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_url = 2;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserFile.prototype.getFileUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserFile} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserFile.prototype.setFileUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UserFile.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserFile} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserFile.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp time_stamp = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.Olameter.GroupManagement.User.v1.UserFile.prototype.getTimeStamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserFile} returns this
*/
proto.Olameter.GroupManagement.User.v1.UserFile.prototype.setTimeStamp = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserFile} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserFile.prototype.clearTimeStamp = function() {
  return this.setTimeStamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.UserFile.prototype.hasTimeStamp = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.Olameter.GroupManagement.User.v1);
